import axios from "axios";

const runtimeApiBaseUrl = window.__ZARKIT_CONFIG__?.apiBaseUrl;
//const API_BASE_URL = (runtimeApiBaseUrl || process.env.REACT_APP_API_BASE_URL || "/api").replace(/\/$/, "");
//const API_BASE_URL = "http://localhost:8080/";
const API_BASE_URL = (
  runtimeApiBaseUrl ||
  process.env.REACT_APP_API_BASE_URL ||
  "https://zarkit.com/api"
).replace(/\/$/, "");
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("loggedIn");
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("role");
    }

    return Promise.reject(error);
  }
);

export default apiClient;
